"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconButtonStyles = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      '&:hover': {
        boxShadow: function boxShadow(_ref) {
          var disabled = _ref.disabled,
              color = _ref.color,
              variant = _ref.variant;
          return !variant ? 'none' : disabled ? 'none' : color === 'primary' ? '0em 0.5rem 0.75rem rgba(137, 182, 32, 0.24)' : 'none';
        }
      },
      borderRadius: '50%',
      border: function border(_ref2) {
        var variant = _ref2.variant;
        return variant === 'outlined' ? "solid 1px ".concat(theme.palette.grey[400]) : 'none';
      },
      boxShadow: function boxShadow(_ref3) {
        var disabled = _ref3.disabled,
            color = _ref3.color,
            variant = _ref3.variant;
        return !variant ? 'none' : disabled ? 'none' : color === 'primary' ? '0em 0.5rem 0.75rem rgba(137, 182, 32, 0.24)' : 'none';
      }
    }
  };
})(_IconButton.default);
var _default = IconButtonStyles;
exports.default = _default;